import React from 'react'
import TextEditor from '../text-editor/TextEditor'

interface IFormTextEditorProps {
  name: string
  field: {name: string; value: any; onChange: () => void}
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  className: string
  loaded: boolean
}

export const FormTextEditor: React.FC<IFormTextEditorProps> = (props) => {
  //console.log(props.field.value)
  return (
    <>
      <TextEditor
        className={props.className}
        name={props.field.name}
        value={props.field.value}
        loaded={props.loaded}
        onChange={(val: any) => {       
          val && props.form.setFieldValue(props.field.name, val)
        }}
      />
    </>
  )
}
